import { TFunction } from 'react-i18next';
import { TaxTypes } from '@/models/common.model';
import { IPartnerProfile } from '@/models/partners.model';
import { PaymentTargetTypes } from './types';

export const getPaymentTargetByTaxType = (taxType?: string): PaymentTargetTypes | undefined => {
  switch (taxType) {
    case TaxTypes.SIMPLE:
      return PaymentTargetTypes.FOP;
    case TaxTypes.GENERAL:
      return PaymentTargetTypes.TOV;
    default:
      return undefined;
  }
};

export const getTaxTypeOptions = (t: TFunction) => {
  return Object.values(TaxTypes).map((item) => ({
    label: t(item, { ns: 'common' }),
    value: item,
  }));
};

export const getActiveOptions = (t: TFunction) => [
  { value: '1', label: t('users_list_active') },
  { value: '0', label: t('users_list_inactive') },
];

export const getHiddenOptions = (t: TFunction) => [
  { value: '0', label: t('users_list_shown_badge') },
  { value: '1', label: t('users_list_hidden_badge') },
];

export const getPartnersOptions = (partners: IPartnerProfile[]) =>
  partners?.map((partner: IPartnerProfile) => ({ label: partner.store?.title ?? '', value: partner.id }));
